// =====================================
//  編輯使用者商品備註 modal
//
//  @author: Gray
//  @time 2016 / 09 / 08
// =====================================

window.InifECMobileApp.directive('editUserremark', ['$rootScope', '$ngModal', '$timeout', 'ShoppingCartService',
    function ($rootScope, $ngModal, $timeout, ShoppingCartService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // -------------------------------
            // 儲存使用者商品備註
            // -------------------------------
            var submit = function() {

                if($scope.isLoading) {
                    return;
                }

                $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                    title: '正在儲存商品備註',
                });

                var orderitemid = $scope.orderitem.orderitemid,
                    userRemark = $scope.form.userRemark,
                    cartType = $scope.cartType;

                $scope.isLoading = true;

                ShoppingCartService.updateUserRemark(orderitemid, userRemark, cartType).then(function() {

                    $scope.isLoading = false;
                    ($scope.callback) && $scope.callback(userRemark);

                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功儲存商品備註',
                    });

                    closeModal();
                }, function(error) {
                    $scope.isLoading = false;
                    $scope.isError = true;

                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                });
            }

            // -------------------------------
            // 離開編輯使用者商品備註
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('edit-userremark-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('edit-userremark-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_EDIT_USERREMARK_MODAL', function(event, data) {
                
                $scope.isLoading = false;

                if(data) {
                    $scope.orderitem = data.orderitem;
                    $scope.callback = data.callback;
                    $scope.cartType = data.cartType;

                    $scope.form.userRemark = $scope.orderitem.userRemark;

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.form = {
                userRemark: '',
            };
            $scope.cartType;
            $scope.isLoading = false;
            $scope.isError = false;

            /*==========================
                Methods
            ==========================*/
            $scope.submit = submit;
            $scope.cancel = cancel; // 離開編輯使用者商品備註
            $scope.callback;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/edit_userremark.html";
        _dir.controller = controller;

        return _dir;
    }]
);